// This function allow to reference chunks
__webpack_require__.u = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "" + ({"182": "gsap-vendor","460": "quickjs-sandbox","498": "geo-vendor",}[chunkId] || chunkId) + "." + {"182": "e1f5614bf758e7a8","396": "8e65d45148f0bd4f","460": "01543003e5e42383","498": "fbe609343933f197","917": "231436a593d46d78","985": "1f73a27b0e7d031d",}[chunkId] + ".chunk.js"
}